(function () {
    'use strict';

    angular
        .module('atheer.session', []);
})();